module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "d2-d5f88a5f148ed-d1e275"
    }
  }, [_c('span', {
    attrs: {
      "id": "page1"
    }
  }, [_c('h2', {
    staticClass: "chapter-number "
  }, [_vm._v("PROLOGUE")]), _vm._v(" "), _c('h2', {
    staticClass: "chapter-title "
  }, [_vm._v("Trangie, New South Wales, Australia")]), _vm._v(" "), _c('div', {
    staticClass: "section",
    attrs: {
      "id": "d2-d5f88a5f148ed-d1e280"
    }
  }, [_c('h3', {
    staticClass: "a-head-space-after italic "
  }, [_c('em', [_c('em', {
    staticClass: "char-italic italic"
  }, [_vm._v("July 21, 1969")])])]), _vm._v(" "), _c('p', {
    staticClass: "flush-left-opener ",
    staticStyle: {
      "text-indent": "0"
    }
  }, [_c('span', {
    staticClass: "drop-cap char-drop-cap"
  }, [_vm._v("U")]), _vm._v("na Ronald’s eyeglasses with the black plastic frames are about to fall off. They’ve slid down her rather long nose while she’s been sleeping, and now that she’s shifted to her side, they’re poised to drop to the floor beside the bed. Her husband, Jock, is snoring next to her like the Aussie lumberjack he once was. Meanwhile, history is about to be made on their brand-new AWA twenty-one-inch ‘Deep Image’ Solid-State television.")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("It’s 5:16 a.m., and the tired anchorman is saying, not for the first time, ‘Ladies and gentlemen, the Australian Broadcasting Corporation tonight is proud to—’ when he is loudly interrupted by his broadcast partner.")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("‘Gord, we’ve got pictures!’")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("The man’s interjection wakes the sleeping woman with a start, her glasses giving in to gravity. Squinting nearsightedly at the TV, she tries to wake her husband.")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("‘Jock, this is it!’")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("The big man simply rolls over. So, she turns back to the TV, leaning over and groping for her glasses on the rug without taking her myopic eyes from the screen. Adding to her focal problems is the billowing dust from the lunar surface that all but obscures the grainy black-and-white images from the Eagle’s camera, dust kicked up by the lunar module’s retro rockets.")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("The second newsman can barely contain himself. ‘We’re first in the world with these pictures, Gord, coming as they do from our own Parkes Observatory right here in New South Wales!’")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("Soon, the sound of Neil Armstrong’s voice cuts through the crackle of hundreds of thousands of miles of static. ‘Houston, Tranquility Base here. The Eagle has landed.’")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("Finally feeling the rims of her spectacles, Mrs Ronald puts them on in time to see something strange: rolling into the lower left-hand side of the picture and nearly hitting one of the Eagle’s extended legs is a bottle of Coca-Cola. And then it disappears.")]), _c('span', {
    attrs: {
      "id": "page2"
    }
  }, [_c('p', {
    staticClass: "indented "
  }, [_vm._v("Could it be? She wipes her lenses on her nightgown and peers through them once more. No Coke bottle. Just the surface of the moon and a hatch that’s opening high in the lunar module for one Neil Armstrong, whose next step really will be history in the making.")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("She reaches for the telephone to call someone. Anyone.")]), _c('span', {
    attrs: {
      "id": "page3"
    }
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dbd18d2a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781448303595_epub_chap001.vue
// module id = 78
// module chunks = 0